import React from 'react'

import Base from '../_Base'

const ChevronLeft = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <polygon
      transform="translate(11.700000, 12.000000) rotate(180.000000) translate(-11.700000, -12.000000) "
      points="8 7.4 9.4 6 15.4 12 9.4 18 8 16.6 12.6 12"
    />
  </Base>
)

export default ChevronLeft
